import React, { Component } from "react";
import { observer } from "mobx-react";
import { Accessor, GFunc, NavX, ResponsiveX } from "IZOX/STATIC";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import PricingPlanM from "./M/PricingPlanM";
import { SysConfig } from "__SYSDefault/Config";
import PricingPlanW from "./W/PricingPlanW";
import { withRouter } from "react-router-dom/cjs/react-router-dom";

/**
 * @augments {Component<Props, State>}
 */
class PricingPlan extends Component {

  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(){
    super();
    this.state = {};
  }

  componentDidMount(){
    this._setAllStates();
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(PricingPlan.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  _toApply = () => {
    let {history} = this.props;
    NavX.Goto(history, "/Login");
  }

  _toPlanDetail = () => {
    GFunc.PreviewPDF("/Documents/PlanDetails.pdf");
  }

  render(){
    return ResponsiveX.Split({
      0: () => <PricingPlanM {...this.props} toApply={this._toApply} toPlanDetail={this._toPlanDetail}/>,
      [SysConfig.WebUIWidth]: () => <PricingPlanW {...this.props}  toApply={this._toApply} toPlanDetail={this._toPlanDetail}/>
    });
  }

}

export default withRouter(observer(PricingPlan));
